<template>
    <v-card class="mx-auto media-card">
        <v-card-title>
            <h3 class="text-h6 font-weight-regular text-left grow subtitle">
                In the Media
            </h3>
        </v-card-title>

        <v-card-text>
            <v-list two-line>
                <template v-for="(item, index) in mediaItems">
                    <v-list-item
                        :key="item.url"
                        :href="item.url"
                        target="_blank"
                        rel="noopener"
                        class="media-item"
                    >
                        <v-list-item-avatar tile size="120" class="mr-4 media-thumb">
                            <v-img :src="item.image" :alt="item.title" cover></v-img>
                        </v-list-item-avatar>

                        <v-list-item-content>
                            <v-list-item-title class="media-title">
                                {{ item.title }}
                            </v-list-item-title>
                            <v-list-item-subtitle class="media-hook">
                                {{ item.hook }}
                            </v-list-item-subtitle>
                            <v-list-item-subtitle class="media-source">
                                {{ item.source }}
                            </v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-action>
                            <v-icon color="teal darken-1">mdi-open-in-new</v-icon>
                        </v-list-item-action>
                    </v-list-item>
                    <v-divider v-if="index < mediaItems.length - 1" :key="'d-' + item.url"></v-divider>
                </template>
            </v-list>
        </v-card-text>
    </v-card>
</template>

<style scoped>
.media-card {
    max-width: 1000px;
}

.subtitle {
    color: #337ab7;
}

.media-item {
    text-decoration: none;
    min-height: 140px;
}

.media-thumb {
    border-radius: 6px;
    overflow: hidden;
}

.media-title {
    font-size: 1.15em;
    font-weight: 600;
    white-space: normal;
    margin-bottom: 4px;
}

.media-hook {
    font-size: 1em;
    color: #333;
    font-style: italic;
    white-space: normal !important;
    -webkit-line-clamp: unset !important;
    margin-bottom: 4px;
}

.media-source {
    font-size: 0.9em;
    color: #666;
}
</style>

<script>
export default {
    data: () => ({
        mediaItems: [
            {
                title: "Optimising drone safety",
                hook: "Can automated drones avoid collisions without revealing their location? Our team found a way — find out more here.",
                source: "University of St. Gallen — HSG at a glance",
                image: "https://www.unisg.ch/fileadmin/_processed_/d/f/csm_SCS_Drohnen_5_2d2a3dea26.jpg",
                url: "https://www.unisg.ch/en/hsg-at-a-glance/optimising-drone-safety/"
            }
        ]
    })
}
</script>
